// Fonte única da modalidade da visita (spec Bruno 20/jul/2026 §1).
//
// O modelo canônico é Presencial / Remota. O valor legado gravado no banco era
// 'telefone' — a migração 20260720130000 normaliza os registros para 'remota',
// mas TODA leitura passa por `isRemota()` para que linhas antigas (ou escritas
// por integrações externas que ainda mandem 'telefone') continuem sendo lidas
// como remotas. Nunca compare `modalidade === 'telefone'` fora daqui: foi
// exatamente esse padrão espalhado que fez remotas contarem como presenciais
// no cálculo de capacidade da rota.

export type Modalidade = 'presencial' | 'remota';

/**
 * O que chega da leitura do banco. Propositalmente `string`: várias telas
 * tipam a coluna como `string | null` e o valor legado 'telefone' ainda pode
 * aparecer. Escritas usam `Modalidade`, que é fechado.
 */
export type ModalidadeRaw = string | null | undefined;

export const MODALIDADE_REMOTA: Modalidade = 'remota';
export const MODALIDADE_PRESENCIAL: Modalidade = 'presencial';

/** true para visita remota, aceitando o valor legado 'telefone'. */
export const isRemota = (m: ModalidadeRaw): boolean => m === 'remota' || m === 'telefone';

/** true para visita presencial (default quando a modalidade vem vazia). */
export const isPresencial = (m: ModalidadeRaw): boolean => !isRemota(m);

/** Normaliza qualquer valor lido do banco para o modelo canônico. */
export const normalizarModalidade = (m: ModalidadeRaw): Modalidade =>
    isRemota(m) ? 'remota' : 'presencial';

/** Rótulo exibido ao usuário — Presencial / Remota em todo o CRM. */
export const modalidadeLabel = (m: ModalidadeRaw): string =>
    isRemota(m) ? 'Remota' : 'Presencial';

/** Emoji usado em toasts e cards compactos. */
export const modalidadeEmoji = (m: ModalidadeRaw): string => (isRemota(m) ? '📞' : '📍');

/**
 * Só a visita presencial ocupa capacidade da rota geográfica e conta para a
 * meta diária de visitas; a remota entra na agenda como "Remotas do dia".
 */
export const ocupaRota = isPresencial;
